export default "__VITE_ASSET__276392f8__"